module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/sample_talk3-45dfb425d310a8d07e7e509d0bcfaaf3.png";